import React, { useEffect, useState } from 'react';
import './styles';
import UIMultiImageSelect from '../../../../../components/UI/UIMultiImageSelect';
import { TYPES } from '../../../../../components/UI/UIMultiImageSelect/config';
import { useLazyQuery } from '@apollo/react-hooks';
import Queries from '../../../../../utils/API/Queries';
import * as strings from './strings';
import { FILE_STATUS_LIVE, FILE_TYPE_IMAGE } from '../../../../../utils/Config/Constants';
import { GET_LISTING_AGGREGATED_IMAGES } from './queries';
import PLUpload from '../../../../../components/PL/PLUpload';
import { useSelector } from 'react-redux';
import { getIsUserAdminSelector, getSignedInUserSelector } from '../../../../../redux/selectors/CurrentUserSelectors';

export default function ListingPhotos({ listingId }: ListingPhotosProps) {
	const signedInUser = useSelector(getSignedInUserSelector);
	const isUserAdmin = useSelector(getIsUserAdminSelector);

	const [aggregatedImages, setAggregatedImages] = useState<FileType[]>();
	const [listing, setListing] = useState<ListingType>();

	const [getListing, { data: listingData }] = useLazyQuery(GET_LISTING_AGGREGATED_IMAGES, { variables: { id: listingId } });
	const [getAggregatedImages, { data: aggregatedImagesData }] = useLazyQuery(Queries.GET_FILES_WITH_QUERY);

	useEffect(() => {
		(async () => {
			await getListing();
		})();
	}, []);

	useEffect(() => {
		if (listingData) {
			const fetchedListing: ListingType = listingData['listing'];
			setListing(fetchedListing);
			const variables: any = {
				order: [['index']],
				limit: 1000,
				query: { listingId: fetchedListing.id, status: FILE_STATUS_LIVE, type: FILE_TYPE_IMAGE, isActive: true }
			};
			if (isUserAdmin) {
				variables.query = {
					op_or: [
						{ listingId: { op_eq: listingId }, type: FILE_TYPE_IMAGE },
						{ listingId: fetchedListing.id, type: FILE_TYPE_IMAGE, isActive: true }
					]
				};
			}
			getAggregatedImages({
				variables
			});
		}
	}, [listingData]);

	useEffect(() => {
		if (aggregatedImagesData) {
			setAggregatedImages(aggregatedImagesData['files']);
		}
	}, [aggregatedImagesData]);

	if (!listing || !aggregatedImages) return null;

	const renderUpload = () => {
		return (
			<PLUpload
				multiple={true}
				postData={{ listingId: listing.id }}
				localeTranslations={strings.imageUploadLocaleTranslations}
				fileType={FILE_TYPE_IMAGE}
				onFileUploadComplete={getListing}
				uploadStatus={FILE_STATUS_LIVE}
			/>
		);
	};

	const getFilteredFiles = () => {
		let files = aggregatedImages;
		if (!isUserAdmin && signedInUser.id === listing.client.id) {
			return files.filter((file) => file.status === FILE_STATUS_LIVE);
		}
		return files;
	};

	const renderContent = () => {
		return (
			<UIMultiImageSelect
				emptySetTitle={strings.emptySetTitle}
				emptySetDescription={strings.emptySetDescription}
				type={TYPES.image}
				updateData={getListing}
				files={getFilteredFiles()}
				listing={listing}
				disableSort={false}
				rightItem={renderUpload()}
			/>
		);
	};

	const renderInfoBanner = () => {
		// if (getFilteredFiles().length !== aggregatedImages.length) {
		// 	return (
		// 		<UINotificationBanner text={'This service has files which require proofing'} className='listingPhotos--proofing' textStyle={{ color: 'var(--red)' }} />
		// 	);
		// }
		return null;
	};

	return (
		<div className='listingPhotos'>
			{renderInfoBanner()}
			{renderContent()}
		</div>
	);
}
